import React from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Checkbox from "@mui/material/Checkbox";
import FileUpload from "../../../common/fileUpload/FileUpload";

function AddHomeGauge(props) {
    const { state, setState, setIsTexasTemplate, isTexasTemplate, selectedType, setSelectedType, inspTypes } = props;

    const { file, progressPercent, selectedCompany, apiCallInProgress, templateFile, listFile } = state;

    const handleCloseDialog = (closeDialog = false, closeFrom = "button", type) => {
        if (type === "template")
            setState((prevState) => ({ ...prevState, templateFile: null, }));
        else
            setState((prevState) => ({ ...prevState, listFile: null }))
    };


    const handleUploadFile = async (file, type) => {
        if (type === "template")
            setState(prevState => ({ ...prevState, templateFile: file }));
        else setState(prevState => ({ ...prevState, listFile: file }));
    };

    const cancelDisabled = () => {
        if (!file) return false;
        else if (apiCallInProgress) return true;
        else if (!selectedCompany?.template_guid) return true;
        else return false;
    };

    return (
        <>
            <Grid container>
                <Grid item xs={0.8}>
                    <Checkbox
                        size="small"
                        id="isTexasTemplate"
                        variant="outlined"
                        value={isTexasTemplate}
                        checked={isTexasTemplate}
                        className="input-textfield"
                        onChange={(e) => setIsTexasTemplate(e.target.checked)}
                    />
                </Grid>
                <Grid item xs={5} mt={0.9}>
                    <label className="input-form-label" htmlFor="payment">
                        TEXAS TREC 7-6
                    </label>
                </Grid>
                <Grid item xs={6} className="mb-34">
                    <label
                        className="pt_input-form-label mb-5"
                        htmlFor="pt_type_insp"
                    >
                        Type of inspection*
                    </label>
                    <FormControl fullWidth>
                        <Autocomplete
                            className={"custom-color arrow-style"}
                            id="pt_type_insp"
                            options={inspTypes}
                            filterSelectedOptions
                            size="small"
                            err
                            value={selectedType}
                            isOptionEqualToValue={(option, value) =>
                                option?.id === value?.id
                            }
                            getOptionLabel={(option) => option.name}
                            onChange={(e, newValue) => {
                                setSelectedType(newValue);
                            }}
                            renderInput={(params) => (
                                <TextField {...params} placeholder="Select type" />
                            )}
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <Typography>{`Template File*`}</Typography>
            <FileUpload
                progressPercent={progressPercent}
                setState={setState}
                state={state}
                file={templateFile}
                handleUploadFile={handleUploadFile}
                cancelDisabled={cancelDisabled}
                handleCloseDialog={handleCloseDialog}
                component={"hip"}
                type={"template"}
            />
            <Typography>{`List File*`}</Typography>
            <FileUpload
                progressPercent={progressPercent}
                setState={setState}
                state={state}
                file={listFile}
                handleUploadFile={handleUploadFile}
                cancelDisabled={cancelDisabled}
                handleCloseDialog={handleCloseDialog}
                component={"hip"}
                type={"list"}
            />
        </>
    );
}

export default AddHomeGauge;